/** @jsxImportSource @emotion/react */
import React from "react";
import { SerializedStyles, css } from "@emotion/react";

interface Props extends React.HTMLAttributes<HTMLFormElement> {
  additionalStyles?: SerializedStyles;
  width?: string;
}

export const StyledForm = ({
  children,
  additionalStyles,
  width,
  ...rest
}: Props) => {
  const formStyle = css`
    display: flex;
    flex-direction: column;
    width: ${width || "100%"};
    align-items: center;
    ${additionalStyles}
  `;

  return (
    <form {...rest} css={formStyle}>
      {children}
    </form>
  );
};
